import {MspAuthorityActions, RegionMspAuthorityActionTypes} from '../actions/region-msp-authority.actions';
import {MspAuthority} from '../region.model';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(state = initialState, action: MspAuthorityActions): State {
  switch (action.type) {
    case RegionMspAuthorityActionTypes.GetMspAuthority:
      return {...state, Loaded: false, Loading: true};

    case RegionMspAuthorityActionTypes.GetMspAuthoritySuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case RegionMspAuthorityActionTypes.UpdateMspAuthority:
      return {...state, Loaded: false, Loading: true};

    case RegionMspAuthorityActionTypes.DeleteMspAuthority:
      return {...state, Loaded: false, Loading: true};

    default:
      return state;
  }
}

